import React, { useEffect, useMemo, useRef } from 'react';
import { resolvePortalOrigin } from '../../utils/scalePortalUrl';

// The booking form is hosted on the Scale Mediation portal (the mediator-facing
// app), NOT the Case Manager app. We embed the portal's own /embed/:mediator
// page — the exact same booking widget clients use — so there is zero drift
// from Scale. The origin resolution (env override, else derive it from the CM
// host) now lives in utils/scalePortalUrl so the Booking Link page, the
// onboarding links and this tab cannot drift apart.

const cardStyle = {
  background: '#fff',
  border: '1px solid #e5e5e5',
  borderRadius: 10,
};

export default function BookingLinkTab({ userId }) {
  const origin = useMemo(() => resolvePortalOrigin(), []);
  // The /embed/:mediator route on the Scale portal resolves the mediator by
  // user_id (uuid), so the embed key is the mediator's user_id.
  const mediatorKey = userId || '';
  const bookingUrl = mediatorKey ? `${origin}/embed/${mediatorKey}` : '';
  const iframeRef = useRef(null);

  // Self-resize: the /embed page posts its content height so the iframe grows
  // to fit the whole booking form (no inner scrollbar) — the same protocol the
  // Scale portal's embed snippet uses.
  useEffect(() => {
    if (!mediatorKey) return undefined;
    const onMessage = (e) => {
      if (e.origin !== origin) return;
      if (!e.data || e.data.type !== 'scale-embed-resize' || e.data.mediator !== mediatorKey) return;
      const f = iframeRef.current;
      if (f && e.data.height) f.style.height = `${e.data.height}px`;
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [origin, mediatorKey]);

  if (!mediatorKey) {
    return (
      <div style={cardStyle} className="p-8 flex items-center justify-center">
        <span className="text-[13px] text-[#5b5a64]" style={{ fontFamily: 'Inter, sans-serif' }}>
          This mediator has no linked account yet, so a booking form can&apos;t be shown.
        </span>
      </div>
    );
  }

  return (
    <div style={cardStyle}>
      <iframe
        ref={iframeRef}
        title="Booking form"
        src={bookingUrl}
        style={{
          width: '100%',
          height: 900,
          border: 0,
          background: 'transparent',
          display: 'block',
          borderRadius: 10,
        }}
        frameBorder="0"
        scrolling="no"
        allow="clipboard-write"
      />
    </div>
  );
}
